import { render } from "./FormError.vue?vue&type=template&id=d4bc538a"
import script from "./FormError.vue?vue&type=script&lang=ts"
export * from "./FormError.vue?vue&type=script&lang=ts"
script.render = render

export default script